import {
  GOOGLE_AUTH_REQUEST,
  GOOGLE_AUTH_RESET,
  SOCIAL_AUTH_ERROR_RESET,
} from "../../modules/constants";

// ------------------------------------
// Actions
// ------------------------------------

/**
 * Google OAuth authentication request
 * @param {Object} payload - { access_token?: string, code?: string, key?: string, id_token?: string }
 */
export function googleAuthRequest(payload) {
  return {
    type: GOOGLE_AUTH_REQUEST,
    payload,
  };
}

/**
 * Reset Google auth state
 */
export function googleAuthReset() {
  return {
    type: GOOGLE_AUTH_RESET,
  };
}

/**
 * Reset social auth error messages
 */
export function socialAuthErrorReset() {
  return {
    type: SOCIAL_AUTH_ERROR_RESET,
  };
}


